export const HOME_GREETING = {
  title: "What would you like to accomplish today?",
  subtitle: "Automate a process, uncover insights, or delegate work to SummitAI.",
  examplesLabel: "See example workflows",
  examplesHideLabel: "Hide examples",
  composerPlaceholder: "Describe a goal, question, process, or task…",
} as const;

export const EXAMPLE_WORKFLOWS = [
  "When an Opportunity is marked Closed Won in Salesforce, create an invoice in QuickBooks.",
  "When a sales order is fulfilled in NetSuite, update the corresponding Salesforce Opportunity with the fulfilment status and shipment date.",
  "When a HubSpot Deal is marked Closed Won, create a sales order in NetSuite.",
  "When an invoice is fully paid in QuickBooks, update the corresponding HubSpot Deal to Paid and create a customer onboarding task.",
] as const;
